import { useState } from 'react';
import type { SearchResults, Track } from '@blackblack/shared';
import { formatDuration } from '@blackblack/shared';
import { api } from '../../lib/api';
import { useQuery } from '../../lib/query';
import { Icon } from '../../components/ui/Icon';
import { Spinner } from '../../components/ui/primitives';
import { Sheet } from '../../components/ui/Sheet';
import { Cover } from '../music/Cover';
import styles from './create.module.css';

/** Pick a sound for a video. Only tracks whose rights allow use in videos are selectable. */
export function SoundPicker({ onPick, onClose }: { onPick: (t: Track) => void; onClose: () => void }) {
  const [q, setQ] = useState('');
  const popular = useQuery<Track[]>('tracks:trending:20', () => api.page<Track>('/music/tracks', { sort: 'trending', limit: 20 }).then((p) => p.items));
  const search = useQuery<SearchResults>(q.trim().length > 1 ? `search:tracks:${q.trim()}` : null, () => api.get('/search', { q: q.trim(), type: 'tracks', limit: 20 }));
  const list = q.trim().length > 1 ? search.data?.tracks : popular.data;
  const loading = q.trim().length > 1 ? search.loading : popular.loading;

  return (
    <Sheet open onClose={onClose} title="Kies een geluid" height="tall">
      <div className={styles.pickerSearch}>
        <Icon name="search" size={18} />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Zoek nummers of artiesten" aria-label="Zoek geluid" autoFocus />
      </div>
      {loading && (
        <div className={styles.pickerCenter}>
          <Spinner />
        </div>
      )}
      <ul className={styles.pickerList}>
        {list?.map((t) => (
          <li key={t.id}>
            <button className={styles.pickerItem} disabled={!t.usableInVideos} onClick={() => onPick(t)}>
              <Cover src={t.coverUrl} size={48} />
              <span className={styles.pickerText}>
                <strong>{t.title}</strong>
                <small>
                  {t.artist.name} · {formatDuration(t.durationSec)} · {t.videoCount} video's
                </small>
                {!t.usableInVideos && <small className={styles.pickerBlocked}>Niet beschikbaar voor video's (rechten)</small>}
              </span>
              {t.usableInVideos && <Icon name="plus" size={20} />}
            </button>
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
